@file:OptIn(InternalResourceApi::class)

package ssinventory.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/ssinventory.shared.generated.resources/"

@delegate:ResourceContentHash(449_277_192)
internal val Res.drawable.arrow: DrawableResource by lazy {
      DrawableResource("drawable:arrow", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_987_776_389)
internal val Res.drawable.asset_1: DrawableResource by lazy {
      DrawableResource("drawable:asset_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/asset_1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-734_435_540)
internal val Res.drawable.asset_2: DrawableResource by lazy {
      DrawableResource("drawable:asset_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/asset_2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-267_254_010)
internal val Res.drawable.asset_3: DrawableResource by lazy {
      DrawableResource("drawable:asset_3", setOf(
        ResourceItem(setOf(), "${MD}drawable/asset_3.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_119_402_795)
internal val Res.drawable.asset_4: DrawableResource by lazy {
      DrawableResource("drawable:asset_4", setOf(
        ResourceItem(setOf(), "${MD}drawable/asset_4.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_042_842_428)
internal val Res.drawable.asset_5: DrawableResource by lazy {
      DrawableResource("drawable:asset_5", setOf(
        ResourceItem(setOf(), "${MD}drawable/asset_5.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_789_349_351)
internal val Res.drawable.asset_6: DrawableResource by lazy {
      DrawableResource("drawable:asset_6", setOf(
        ResourceItem(setOf(), "${MD}drawable/asset_6.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(104_050_636)
internal val Res.drawable.boo_blacks: DrawableResource by lazy {
      DrawableResource("drawable:boo_blacks", setOf(
        ResourceItem(setOf(), "${MD}drawable/boo_blacks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(104_050_636)
internal val Res.drawable.boo_red_rectangle: DrawableResource by lazy {
      DrawableResource("drawable:boo_red_rectangle", setOf(
        ResourceItem(setOf(), "${MD}drawable/boo_red_rectangle.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_328_630_761)
internal val Res.drawable.calendar: DrawableResource by lazy {
      DrawableResource("drawable:calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/calendar.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_067_973_884)
internal val Res.drawable.close: DrawableResource by lazy {
      DrawableResource("drawable:close", setOf(
        ResourceItem(setOf(), "${MD}drawable/close.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_799_579_144)
internal val Res.drawable.daily: DrawableResource by lazy {
      DrawableResource("drawable:daily", setOf(
        ResourceItem(setOf(), "${MD}drawable/daily.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_940_107_361)
internal val Res.drawable.delivery: DrawableResource by lazy {
      DrawableResource("drawable:delivery", setOf(
        ResourceItem(setOf(), "${MD}drawable/delivery.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_480_047_214)
internal val Res.drawable.folder: DrawableResource by lazy {
      DrawableResource("drawable:folder", setOf(
        ResourceItem(setOf(), "${MD}drawable/folder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_643_861_697)
internal val Res.drawable.maintenance: DrawableResource by lazy {
      DrawableResource("drawable:maintenance", setOf(
        ResourceItem(setOf(), "${MD}drawable/maintenance.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-861_478_314)
internal val Res.drawable.prep: DrawableResource by lazy {
      DrawableResource("drawable:prep", setOf(
        ResourceItem(setOf(), "${MD}drawable/prep.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_228_081_370)
internal val Res.drawable.reports: DrawableResource by lazy {
      DrawableResource("drawable:reports", setOf(
        ResourceItem(setOf(), "${MD}drawable/reports.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_290_177_906)
internal val Res.drawable.services: DrawableResource by lazy {
      DrawableResource("drawable:services", setOf(
        ResourceItem(setOf(), "${MD}drawable/services.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_383_804_614)
internal val Res.drawable.settings: DrawableResource by lazy {
      DrawableResource("drawable:settings", setOf(
        ResourceItem(setOf(), "${MD}drawable/settings.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_097_688_955)
internal val Res.drawable.stock: DrawableResource by lazy {
      DrawableResource("drawable:stock", setOf(
        ResourceItem(setOf(), "${MD}drawable/stock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_855_521_224)
internal val Res.drawable.suppliers: DrawableResource by lazy {
      DrawableResource("drawable:suppliers", setOf(
        ResourceItem(setOf(), "${MD}drawable/suppliers.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-308_239_909)
internal val Res.drawable.tools: DrawableResource by lazy {
      DrawableResource("drawable:tools", setOf(
        ResourceItem(setOf(), "${MD}drawable/tools.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-512_178_262)
internal val Res.drawable.training: DrawableResource by lazy {
      DrawableResource("drawable:training", setOf(
        ResourceItem(setOf(), "${MD}drawable/training.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("arrow", Res.drawable.arrow)
  map.put("asset_1", Res.drawable.asset_1)
  map.put("asset_2", Res.drawable.asset_2)
  map.put("asset_3", Res.drawable.asset_3)
  map.put("asset_4", Res.drawable.asset_4)
  map.put("asset_5", Res.drawable.asset_5)
  map.put("asset_6", Res.drawable.asset_6)
  map.put("boo_blacks", Res.drawable.boo_blacks)
  map.put("boo_red_rectangle", Res.drawable.boo_red_rectangle)
  map.put("calendar", Res.drawable.calendar)
  map.put("close", Res.drawable.close)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("daily", Res.drawable.daily)
  map.put("delivery", Res.drawable.delivery)
  map.put("folder", Res.drawable.folder)
  map.put("maintenance", Res.drawable.maintenance)
  map.put("prep", Res.drawable.prep)
  map.put("reports", Res.drawable.reports)
  map.put("services", Res.drawable.services)
  map.put("settings", Res.drawable.settings)
  map.put("stock", Res.drawable.stock)
  map.put("suppliers", Res.drawable.suppliers)
  map.put("tools", Res.drawable.tools)
  map.put("training", Res.drawable.training)
}
